export default "__VITE_ASSET__00dc16f0__"